import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { FileService } from 'src/app/services/file.service';
import { DownloadedFile } from '../../file-remitance/models/downloadFile';
import { mockReceivingBatchCollectors, mockReceivingLineCollectors } from '../objects.spec';

@Injectable({
    providedIn: 'root',
})
export class CollectorFileManageService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig, private fileService: FileService) {}

    private batchCollectorsList = new BehaviorSubject(mockReceivingBatchCollectors);
    private lineCollectorsList = new BehaviorSubject(mockReceivingLineCollectors);

    getReceivingBatchs(params: any): Observable<any> {
        return this.http.get(`${this.API_URL}ReceivingCollector/Batch/ToManage`, params);
    }

    deleteReceivingBatchs(id: string): Observable<any> {
        return this.http.delete(`${this.API_URL}ReceivingCollector/Batch/${id}/DeleteBatch`);
    }

    countBacth(params: any) {
        return this.http.get<ResponseCustom>(`${this.API_URL}ReceivingCollector/Batch/Count`, params);
    }

    DownloadFile(legalEntityId: string, fileName: string): Observable<DownloadedFile> {
        return this.http
            .get(`${this.API_URL}ReceivingCollector/Batch/DownloadFile/${legalEntityId}/${fileName}`, {
                responseType: 'arraybuffer',
                observe: 'response',
            })
            .pipe(
                map((httpResponse: HttpResponse<ArrayBuffer>) =>
                    this.fileService.extractFileNameAndBlobService(httpResponse),
                ),
            );
    }
}
